<script setup lang="ts">
import CustomerContact from '@/components/core/customers/CustomerContact.vue'
import { useCustomers } from '@/composables/core/customers'
import { Icon } from '@iconify/vue'
import { computed } from 'vue'

const props = defineProps<{ customerId: number }>()
const { customerId } = props

const cardsAmount = computed(() =>
  data.value
    ? [
        data.value.operations_contact,
        data.value.billing_contact,
        data.value.corporate_address,
        data.value.billing_address,
      ].filter((card) => card).length
    : 0
)

const { getSingleCustomerQuery } = useCustomers()
const { data, isFetching, isRefetching, isError, error, refetch } = getSingleCustomerQuery(customerId)

const defaultOperationsContact = computed(() => {
  if (!data.value) return undefined
  return {
    company_name: data.value.company_name ?? null,
    first_name: data.value.first_name ?? null,
    last_name: data.value.last_name ?? null,
    email: data.value.email ?? null,
    phone: data.value.phone ?? null,
  }
})
</script>

<template>
  <rl-error-result v-if="isError && !isRefetching" :error="error">
    <el-button @click="refetch()">
      <Icon icon="material-symbols:refresh-rounded" height="16" width="16" :inline="true" />&nbsp;Reload
    </el-button>
  </rl-error-result>
  <el-skeleton v-else :loading="isFetching || isRefetching" animated>
    <template #template>
      <div class="contact__cards">
        <el-skeleton-item class="h-[196px] w-[548px]" variant="rect" />
        <el-skeleton-item class="h-[196px] w-[548px]" variant="rect" />
        <el-skeleton-item class="h-[196px] w-[548px]" variant="rect" />
        <el-skeleton-item class="h-[196px] w-[548px]" variant="rect" />
      </div>
    </template>
    <template v-if="data" #default>
      <div :class="`w-fit grid gap-spacing-lg grid-cols-1 ${cardsAmount > 2 ? '2xl:grid-cols-2' : ''} contact__cards`">
        <details-card v-if="data.operations_contact" title="Operations Contact">
          <customer-contact :contact="data.operations_contact" />
        </details-card>
        <details-card v-else title="Contact">
          <customer-contact v-if="defaultOperationsContact" :contact="defaultOperationsContact" />
        </details-card>
        <details-card v-if="data.billing_contact" title="Billing Contact">
          <customer-contact :contact="data.billing_contact" />
        </details-card>
        <details-card v-if="data.corporate_address" title="Corporate Address">
          <customer-address :address="data.corporate_address" />
        </details-card>
        <details-card v-if="data.billing_address" title="Billing Address">
          <customer-address :address="data.billing_address" />
        </details-card>
      </div>
    </template>
  </el-skeleton>
</template>
